// Get all elements with the class 'em-country-picker__current'
const activeElements = document.querySelectorAll('.em-country-picker__current');

// Get all elements with the class 'em-country-picker__options'
const optionsElements = document.querySelectorAll('.em-country-picker__options');

// Get all parent containers (i.e., the .em-country-picker elements)
const countryPickerElements = document.querySelectorAll('.em-country-picker');

// Check if the elements exist to avoid errors
if (activeElements.length && optionsElements.length && countryPickerElements.length) {
    activeElements.forEach((activeElement, index) => {
        // Get the corresponding options element and countryPicker element based on the index
        const optionsElement = optionsElements[index];
        const countryPickerElement = countryPickerElements[index];

        // Toggle the 'em-country-picker__options--active' class on click
        activeElement.addEventListener('click', function(event) {
            // Prevent click from propagating to the document, which would trigger closing
            event.stopPropagation();

            // Toggle the 'em-country-picker__options--active' class on the options element
            optionsElement.classList.toggle('em-country-picker__options--active');

            // Toggle the 'em-country-picker__current--open' class on the 'em-country-picker__current' element
            activeElement.classList.toggle('em-country-picker__current--open');
        });

        // Close the options when clicking outside the .em-country-picker
        document.addEventListener('click', function(event) {
            if (!countryPickerElement.contains(event.target)) {
                optionsElement.classList.remove('em-country-picker__options--active');
                activeElement.classList.remove('em-country-picker__current--open'); // Close the 'current' element as well
            }
        });
    });
}
